import { Outlet } from "react-router-dom";

const Team = () => {
  return (
    <div>
      <section className="inner_page_breadcrumb">
        <div className="container">
          <div className="row">
            <div className="col-xl-6">
              <div className="breadcrumb_content">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">Home</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Team
                  </li>
                </ol>
                <h4 className="breadcrumb_title">Our Team</h4>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="our-team">
        <div className="container">
          <div className="row">
            <div className="col-md-4 col-lg-3 mb-4">
              <div className="team_member">
                <div className="thumb">
                  <img
                    className="img-fluid"
                    src="assets/img/team-1.jpg"
                    alt="1.jpg"
                  />
                  <div className="overylay">
                    <ul className="social_icon">
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-facebook"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-twitter"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-instagram"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-pinterest"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-dribbble"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-google"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="details">
                  <h4>Jennifer Barton</h4>
                  <p>Broker</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 mb-4">
              <div className="team_member">
                <div className="thumb">
                  <img
                    className="img-fluid"
                    src="assets/img/team-2.jpg"
                    alt="2.jpg"
                  />
                  <div className="overylay">
                    <ul className="social_icon">
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-facebook"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-twitter"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-instagram"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-pinterest"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-dribbble"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-google"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="details">
                  <h4>Kathleen Myers</h4>
                  <p>Agent</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 mb-4">
              <div className="team_member">
                <div className="thumb">
                  <img
                    className="img-fluid"
                    src="assets/img/team-3.jpg"
                    alt="3.jpg"
                  />
                  <div className="overylay">
                    <ul className="social_icon">
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-facebook"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-twitter"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-instagram"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-pinterest"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-dribbble"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-google"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="details">
                  <h4>Mariusz Ciesla</h4>
                  <p>Broker</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 mb-4">
              <div className="team_member">
                <div className="thumb">
                  <img
                    className="img-fluid"
                    src="assets/img/team-4.jpg"
                    alt="4.jpg"
                  />
                  <div className="overylay">
                    <ul className="social_icon">
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-facebook"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-twitter"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-instagram"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-pinterest"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-dribbble"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-google"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="details">
                  <h4>Helene Powers</h4>
                  <p>Broker</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 mb-4">
              <div className="team_member">
                <div className="thumb">
                  <img
                    className="img-fluid"
                    src="assets/img/team-1.jpg"
                    alt="1.jpg"
                  />
                  <div className="overylay">
                    <ul className="social_icon">
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-facebook"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-twitter"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-instagram"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-pinterest"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-dribbble"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-google"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="details">
                  <h4>Jennifer Barton</h4>
                  <p>Broker</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 mb-4">
              <div className="team_member">
                <div className="thumb">
                  <img
                    className="img-fluid"
                    src="assets/img/team-2.jpg"
                    alt="2.jpg"
                  />
                  <div className="overylay">
                    <ul className="social_icon">
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-facebook"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-twitter"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-instagram"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-pinterest"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-dribbble"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-google"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="details">
                  <h4>Kathleen Myers</h4>
                  <p>Agent</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 mb-4">
              <div className="team_member">
                <div className="thumb">
                  <img
                    className="img-fluid"
                    src="assets/img/team-3.jpg"
                    alt="3.jpg"
                  />
                  <div className="overylay">
                    <ul className="social_icon">
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-facebook"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-twitter"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-instagram"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-pinterest"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-dribbble"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-google"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="details">
                  <h4>Mariusz Ciesla</h4>
                  <p>Broker</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 mb-4">
              <div className="team_member">
                <div className="thumb">
                  <img
                    className="img-fluid"
                    src="assets/img/team-4.jpg"
                    alt="4.jpg"
                  />
                  <div className="overylay">
                    <ul className="social_icon">
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-facebook"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-twitter"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-instagram"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-pinterest"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-dribbble"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a href="#">
                          <i className="fa fa-google"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="details">
                  <h4>Helene Powers</h4>
                  <p>Broker</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Outlet />
    </div>
  );
};

export default Team;
